var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7682 9.39616C11.1441 9.39616 11.4557 9.70783 11.4557 10.0837L11.4557 14.667C11.4557 15.0428 11.1441 15.3545 10.7682 15.3545C10.3924 15.3545 10.0807 15.0428 10.0807 14.667L10.0807 10.0837C10.0807 9.70783 10.3924 9.39616 10.7682 9.39616Z",
    fill: "#1462AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1166 6.49032C11.0066 6.44449 10.8874 6.41699 10.7682 6.41699C10.6491 6.41699 10.5299 6.44449 10.4199 6.49032C10.3099 6.53615 10.2091 6.60032 10.1174 6.68282C10.0349 6.77449 9.97073 6.86615 9.9249 6.98532C9.87906 7.09532 9.85156 7.21449 9.85156 7.33366C9.85156 7.45282 9.87906 7.57199 9.9249 7.68199C9.97073 7.79199 10.0349 7.89282 10.1174 7.98449C10.2091 8.06699 10.3099 8.13115 10.4199 8.17699C10.6399 8.26865 10.8966 8.26865 11.1166 8.17699C11.2266 8.13115 11.3274 8.06699 11.4191 7.98449C11.5016 7.89282 11.5657 7.79199 11.6116 7.68199C11.6574 7.57199 11.6849 7.45282 11.6849 7.33366C11.6849 7.21449 11.6574 7.09532 11.6116 6.98532C11.5657 6.86615 11.5016 6.77449 11.4191 6.68282C11.3274 6.60032 11.2266 6.53615 11.1166 6.49032Z",
    fill: "#1462AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7682 20.6253C5.3324 20.6253 0.914062 16.207 0.914062 10.7712C0.914062 5.33533 5.3324 0.916992 10.7682 0.916992C16.2041 0.916992 20.6224 5.33533 20.6224 10.7712C20.6224 16.207 16.2041 20.6253 10.7682 20.6253ZM10.7682 2.29199C6.09323 2.29199 2.28906 6.09616 2.28906 10.7712C2.28906 15.4462 6.09323 19.2503 10.7682 19.2503C15.4432 19.2503 19.2474 15.4462 19.2474 10.7712C19.2474 6.09616 15.4432 2.29199 10.7682 2.29199Z",
    fill: "#1462AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/InfoOutlined.e519fdb4e5ed2ef243f4619a88a70eb7.svg";
export { ForwardRef as ReactComponent };